module.exports = __webpack_public_path__ + "img/farmacon.1cb6a100.png";